module.exports = __webpack_public_path__ + "img/icon1.f86d06e5.png";